<template>
    <MainLayout v-if="authenticated">
        <App v-loading="loading.global"></App>
    </MainLayout>
    <LoginLayout v-else v-loading="loading.global">
        <router-view></router-view>
    </LoginLayout>

</template>

<script>
    import { mapState, createNamespacedHelpers } from 'vuex';
    import MainLayout from './layouts/MainLayout';
    import App from './App';
    import LoginLayout from './layouts/LoginLayout';

    const { mapGetters, mapMutations } = createNamespacedHelpers('auth')
    export default {
        name: 'authorized',
        components: {LoginLayout, App, MainLayout,},
        computed: {
            ...mapState(['loading']),
            ...mapGetters(['authenticated'])
        },
        methods:{
            ...mapMutations(['reloadAuth']),
        },
        created() {
            this.reloadAuth();
        }
    }
</script>

<style>
    html, body{
        margin: 0;
        padding: 0;
        height: 100%;
    }

    input, label, span, div, h1, h2, h3, button, textarea {
        font-family: 'Noto Sans TC', sans-serif !important;
    }

</style>


